/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { useCallback } from "react";
import { CosmosImageType, useCosmosComponentContext } from "@components/context";

export interface CosmosImageProps extends CosmosImageType {
	mediaRef?: (el: HTMLImageElement | null) => void;
}

export const CosmosImage = ({ mediaRef, ...props }: CosmosImageProps): React.JSX.Element | null => {
	const { Image } = useCosmosComponentContext();

	const wrapperRef = useCallback(
		(el: HTMLSpanElement | null) => {
			if (!mediaRef) return;
			const img = el?.querySelector("img") ?? null;
			mediaRef(img);
		},
		[mediaRef],
	);

	if (!props.src) {
		return null;
	}

	if (mediaRef) {
		return (
			<span ref={wrapperRef} style={{ display: "contents" }}>
				<Image {...props} />
			</span>
		);
	}

	return <Image {...props} />;
};
